<script setup lang="ts">
useHead({
	link: [
		{
			rel: 'apple-touch-icon',
			sizes: '180x180',
			href: 'https://ehsv.org/apple-touch-icon.png',
		},
		{
			rel: 'apple-touch-icon',
			sizes: '120x120',
			href: 'https://ehsv.org/apple-touch-icon-120x120.png',
		},
		{
			rel: 'apple-touch-icon',
			sizes: '152x152',
			href: 'https://ehsv.org/apple-touch-icon-152x152.png',
		},
	]
})
</script>

<template>
    <UApp>
        <NuxtRouteAnnouncer />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
</template>